import AISApi from "./AISApi";
import Modal from "../Helpers/UI/Modal";
import { blockScroll, hide, hideAndBlockScroll, show, unblockScroll } from "../Helpers/helpers";
import Message from "../Helpers/UI/Message";
import { getMessage } from "../Helpers/Datas/messages";
import { handleAriaExpandedClick } from "../Helpers/Accesibility/Expanded";
import { addMTOAttributes, checkMTOInventory, removeMTOAttributes } from "../Helpers/MTOHelpers";

class ProductAIS {
    /** @type {string} */
    zipCode = "";
    /** @type {string} */
    zipInvalidMessage = "";
    /** @type {Array} */
    stores = [];
    /** @type {boolean} */
    alpine = true;
    /** @type {boolean} */
    zipValid = false;
    /** @type {boolean} */
    loader = false;
    /** @type {string} */
    variantId = "";
    /** @type {?AISApi} */
    aisApi = null;

    constructor(variantId = null) {
        this.variantId = variantId ? variantId : this.$el.querySelector('.shopify-product-form [name="id"]')?.value;
        this.aisApi = new AISApi();
    }

    reloadDataOnVariantChange() {
        document.addEventListener("luc:variant:changed", (event) => {
            this.variantId = event.detail.variantId;
            this.getAisData();
        });
    }

    async init() {
        this.reloadDataOnVariantChange();
        await this.getAisData();
    }

    showModal() {
        Modal.getModalByName("ais").delay = 500;
        Modal.getModalByName("ais").onOpened = (modal) => {
            modal.getModalElement().classList.remove("tw-translate-x-full");
            blockScroll();
        };
        Modal.getModalByName("ais").onClosing = (modal) => {
            modal.getModalElement().classList.add("tw-translate-x-full");
            unblockScroll();
        };
        Modal.getModalByName("ais").show();
        hideAndBlockScroll("html");
    }

    getAisDataByGeolocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.getAisData([`lat=${position.coords.latitude}`, `lng=${position.coords.longitude}`]);
            });
        } else {
            Message.displayMessage(getMessage("ais.geolocationNotSupported"), "ais", "error");
        }
        this.zipCode = "";
    }

    isValidUSZip(sZip) {
        return /^\d{5}(-\d{4})?$/.test(sZip);
    }

    validateUSZip(sZip) {
        this.zipValid = this.isValidUSZip(sZip);
    }

    resetZipCode() {
        this.zipCode = "";
        this.zipInvalidMessage = "";
        this.getAisData();
    }

    submit() {
        if (this.zipCode.length > 2) {
            this.validateUSZip(this.zipCode);
            if (this.zipValid) {
                this.getAisData();
            } else {
                this.zipInvalidMessage = "Invalid Zip Code";
            }
        } else {
            this.zipInvalidMessage = "You have to fill a Zip code field";
        }
    }

    a11yExpandedClick(event) {
        handleAriaExpandedClick(event);
    }

    async getAisData(parameters = [], successCallback = null, errorCallback = null, finalCallback = null) {
        this.loader = true;
        await this.aisApi.getAisData(
            this.variantId,
            parameters.length > 0 ? parameters : [this.zipCode ? "zipcode=" + this.zipCode : ""],
            (response) => {
                this.stores = response?.data;
                if (successCallback && typeof successCallback === "function") {
                    successCallback(response);
                }
                if (this.stores.length <= 0) {
                    Message.displayMessage(getMessage("ais.empty"), "ais", "error");
                } else {
                    Message.displayMessage(getMessage("ais.notFoundStores"), "ais", "error");
                }
                this.loader = false;
            },
            (exception) => {
                this.zipValid = false;
                this.zipInvalidMessage = exception.message;
                if (errorCallback && typeof errorCallback === "function") {
                    errorCallback(exception);
                }
                Message.displayMessage(getMessage("ais.empty"), "ais", "error");
                this.loader = false;
            },
            () => {
                if (finalCallback && typeof finalCallback === "function") {
                    finalCallback();
                }
                this.loader = false;
            }
        );
    }

    isAvailableInStore() {
        return this.stores.some((store) => store.available);
    }

    /* START | methods to remove/refactor after selectCallback.js refactor */
    showCTAType(productId, type) {
        const atcBtns = document.querySelectorAll(".product-" + productId + ' [data-cta-type="' + type + '"]');
        atcBtns.forEach((atcBtn) => {
            show(atcBtn);
        });
    }
    hideAllCTATypes(productId) {
        const ctaAreas = document.querySelectorAll(".product-" + productId + " [data-cta-type]");
        ctaAreas.forEach((ctaArea) => {
            hide(ctaArea);
        });
    }
    checkAvailabilityForCTO(productId) {
        const klaviyoBisBtns = document.querySelectorAll(".klaviyo-bis-trigger");
        const loaderEl = document.querySelector("[data-basic-loader]");
        const chooseSizeContentEl = document.querySelector("[data-choose-size-content]");
        let isAvailableInStore = false;
        if (loaderEl) {
            loaderEl.classList.add("active");
        }
        removeMTOAttributes(productId);
        this.getAisData(
            [],
            () => {
                isAvailableInStore = this.isAvailableInStore();
                this.hideAllCTATypes(productId);
                if (isAvailableInStore) {
                    this.showCTAType(productId, "cto");
                    klaviyoBisBtns.forEach((klaviyoBisBtn) => {
                        hide(klaviyoBisBtn, true);
                    });
                    chooseSizeContentEl?.classList.add("tw-pb-44");
                } else {
                    this.showCTAType(productId, "notify-me");
                    chooseSizeContentEl?.classList.remove("tw-pb-44");
                }
            },
            () => {},
            () => {
                if (loaderEl) {
                    loaderEl.classList.remove("active");
                }
            }
        );
    }
    setMTOVisibility(productId, variant) {
        removeMTOAttributes(productId);
        if (checkMTOInventory(productId, variant)) {
            this.hideAllCTATypes(productId);
            this.showCTAType(productId, "mto");
            addMTOAttributes(productId);
        }
    }
}

export { ProductAIS };
